var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 66,
    viewBox: "0 0 49 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_2146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3471 0H0V66H49V22.0107L27.3471 0ZM28.2758 5.49897L43.6154 21.0938H28.2758V5.49897ZM3.16884 62.7784V3.22157H25.107V24.3154H45.8312V62.7784H3.16884Z",
    fill: "#FAAC2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7384 35.8809H11.2616V39.1024H37.7384V35.8809Z",
    fill: "#FAAC2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7384 43.5903H11.2616V46.8119H37.7384V43.5903Z",
    fill: "#FAAC2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7384 51.2998H11.2616V54.5214H37.7384V51.2998Z",
    fill: "#FAAC2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_2146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.b82b6d0ed558d506907029a1b5047e1b.svg";
export { ForwardRef as ReactComponent };